import { normalizeCategoryOrder } from '@/entities/clients-categories';
import { repairStoredOrder } from '@/entities/clients-categories-order.storage';
import type { ClientsListType } from '@/entities/clients-filter.entity';
import { createEvent, createStore } from 'effector';

const STORAGE_KEY = 'crave:clients-category-order';

function readStoredOrder(): ClientsListType[] {
	const raw = localStorage.getItem(STORAGE_KEY);
	const { order, needsWrite } = repairStoredOrder(raw);
	if (needsWrite) writeStoredOrder(order);
	return order;
}

function writeStoredOrder(order: ClientsListType[]) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(order));
	} catch {
		// ignore quota / private mode
	}
}

export const $setClientsCategoryOrder = createEvent<ClientsListType[]>();
export const $reorderClientsCategory = createEvent<{ activeId: ClientsListType; overId: ClientsListType }>();

export const $clientsCategoryOrder = createStore<ClientsListType[]>(readStoredOrder())
	.on($setClientsCategoryOrder, (_, order) => normalizeCategoryOrder(order))
	.on($reorderClientsCategory, (order, { activeId, overId }) => {
		const from = order.indexOf(activeId);
		const to = order.indexOf(overId);
		if (from === -1 || to === -1 || from === to) return order;

		const next = [...order];
		const [moved] = next.splice(from, 1);
		next.splice(to, 0, moved);
		return next;
	});

$clientsCategoryOrder.watch(order => {
	writeStoredOrder(order);
});
